import { getOwner } from '@ember/application';

const refreshRoute = (context, routeName) => {
  const route = getOwner(context).lookup(`route:${routeName}`);
  route.refresh();
};

export default refreshRoute;
